import { atom, useAtom } from "jotai";
import dataService from "../../helpers/dataService";

export const cancelReasonsAtom = atom([]);

const useCancelReasons = () => {
  const [cancelReasons, setCancelReasons] = useAtom(cancelReasonsAtom);

  const getCancelReasons = () => {
    dataService.get(`constants/motifs-suspension-resiliation`, (data) =>
      setCancelReasons(
        (data || []).map(({ id, libelle }) => ({ id, name: libelle })),
      ),
    );
  };

  return { getCancelReasons, cancelReasons };
};

export default useCancelReasons;
